// extracted by mini-css-extract-plugin
export default {"tagsView":"TagsView_tagsView__RpObb","square":"TagsView_square__tT9sF","known":"TagsView_known__JL4+x","shouldLearn":"TagsView_shouldLearn__E3g42"};